import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import Dashboard from './Dashboard';

const SupportTicketsApp = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPermission="support-tickets:read" requiredRole="admin">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/support-tickets" replace />} />
    </Routes>
  );
};

export default SupportTicketsApp;
